import { render, staticRenderFns } from "./DogovorKomissii.vue?vue&type=template&id=79de3480&scoped=true&"
import script from "./DogovorKomissii.vue?vue&type=script&lang=js&"
export * from "./DogovorKomissii.vue?vue&type=script&lang=js&"
import style0 from "./DogovorKomissii.vue?vue&type=style&index=0&id=79de3480&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79de3480",
  null
  
)

component.options.__file = "DogovorKomissii.vue"
export default component.exports